(() => {
      const VERSION = 'dm-2d-synced-pill-v2';
      const STEP_MS = 3300;
      const MOVE_MS = 820;

      if (window.DMProductCardRoller && window.DMProductCardRoller.version === VERSION) {
        window.DMProductCardRoller.init(true);
        return;
      }

      let ticker = null;

      const getTracks = () => {
        return Array.from(document.querySelectorAll('[data-dm-roll-track]'));
      };

      const prepareTrack = (track) => {
        const holder = track.closest('.dm-card__offer-badge, .dm-card__highlight');
        if (!holder) return null;

        const allLines = Array.from(track.querySelectorAll('.dm-card__roll-line'));
        const count = Number(track.dataset.dmRollCount || holder.style.getPropertyValue('--dm-roll-count')) || allLines.length || 1;
        const lines = allLines.slice(0, count);

        if (lines.length <= 1) return null;

        allLines.forEach((line, index) => {
          line.style.transitionDuration = `${MOVE_MS}ms`;
          line.style.display = index < count ? '' : 'none';
          line.classList.remove('is-active', 'is-leaving');
          line.setAttribute('aria-hidden', 'true');
        });

        lines[0].classList.add('is-active');
        lines[0].setAttribute('aria-hidden', 'false');

        track.dmRollLines = lines;
        track.dataset.dmRollIndex = '0';
        track.dataset.dmRollReady = 'true';

        return track;
      };

      const tickTrack = (track) => {
        const lines = track.dmRollLines || Array.from(track.querySelectorAll('.dm-card__roll-line'));
        if (!lines || lines.length <= 1) return;

        const currentIndex = Number(track.dataset.dmRollIndex || 0) || 0;
        const nextIndex = (currentIndex + 1) % lines.length;

        const current = lines[currentIndex];
        const next = lines[nextIndex];

        if (!current || !next || current === next) return;

        lines.forEach((line, index) => {
          if (index !== currentIndex && index !== nextIndex) {
            line.classList.remove('is-active', 'is-leaving');
            line.setAttribute('aria-hidden', 'true');
          }
        });

        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        current.setAttribute('aria-hidden', 'true');

        next.classList.remove('is-active', 'is-leaving');
        next.setAttribute('aria-hidden', 'false');

        next.offsetHeight;
        next.classList.add('is-active');

        track.dataset.dmRollIndex = String(nextIndex);
      };

      const tickAll = () => {
        getTracks().forEach((track) => {
          if (track.dataset.dmRollReady === 'true') {
            tickTrack(track);
          }
        });
      };

      const setupRollers = (force = false) => {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const prepared = [];

        getTracks().forEach((track) => {
          if (!force && track.dataset.dmRollReady === 'true') {
            prepared.push(track);
            return;
          }

          const readyTrack = prepareTrack(track);
          if (readyTrack) {
            prepared.push(readyTrack);
          }
        });

        if (ticker) {
          window.clearInterval(ticker);
          ticker = null;
        }

        if (prepared.length > 0) {
          ticker = window.setInterval(tickAll, STEP_MS);
        }
      };

      window.DMProductCardRoller = {
        version: VERSION,
        init: setupRollers
      };

      let resizeQueued = false;

      window.addEventListener('resize', () => {
        if (resizeQueued) return;
        resizeQueued = true;

        requestAnimationFrame(() => {
          resizeQueued = false;
          setupRollers(true);
        });
      }, { passive: true });

      document.addEventListener('shopify:section:load', () => {
        requestAnimationFrame(() => setupRollers(true));
      });

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          setupRollers(true);
        }
      });

      const runSetup = () => requestAnimationFrame(() => setupRollers(true));

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', runSetup, { once: true });
      } else {
        runSetup();
      }
    })();
